<app-complex-modal-template
    [canClose]="false"
    [isConfirmationMode]="false"
    [title]="data.titleKey | transloco">
    <ng-container>
        <p>
            {{ data.descriptionKey | transloco }}
        </p>
        <app-progress-bar
            [itemsLoaded]="updateFieldInterventionService.progressValue()"
            [total]="updateFieldInterventionService.progressTotal()" />
    </ng-container>
</app-complex-modal-template>
